export default{
    
    data() {
        return{
            TransLogs:[],
            recordtotal:0,
            pageSize:10,
            pageIndex:1,
            sBillNo:'',
            sDeveliverDtFrom:'',
            sDeveliverDtTo:'',
            sStoreDtFrom:'',
            sStoreDtTo:'',
            sDestination:'',
            sReceiptStatus:'',
            sGoodsStatus:'',
            sPO:'',
            collapsed:false,
            statusItems:[
                {Id:'C',Text:'无异常'},
                {Id:'L',Text:'多货'},
                {Id:'M',Text:'少货'},
                {Id:'N',Text:'未签收'}
            ],
            rstatusitems:[
                {Id:'Y',Text:'已回'},
                {Id:'N',Text:'未回'},
                {Id:'X',Text:'无'}
            ],
            tableHeight:''
        }
    },
    mounted () {
        var me = this;
        this.LoadData();

        var element = document.getElementById('content');
        this.tableHeight = window.innerHeight - element.offsetTop - 100;
    },
    methods: {
        LoadData(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getLogsMethod = 'TransLog/gettranslogs';
            this.$axios.get(getLogsMethod,
                {
                    params: {
                        'CurrentTokenId': user.TokenId,
                        'CurrentUser': user.LoginName, 
                        'DeveliverDtFrom':me.sDeveliverDtFrom,
                        'DeveliverDtTo':me.sDeveliverDtTo,
                        'DeveliverDtOrder':'',
                        'Destination':me.sDestination,
                        'DestinationOrder':'',
                        'StoreDtFrom':me.sStoreDtFrom,
                        'StoreDtTo':me.sStoreDtTo,
                        'StoreDtOrder':'',
                        'Receiver':'',
                        'ReceiverOrder':'',
                        'BillNo':me.sBillNo,
                        'BillNoOrder':'',
                        'Terminalinventory':'',
                        'TerminalinventoryOrder':'',
                        'ReceiptStatus':me.sReceiptStatus,
                        'ReceiptStatusOrder':'',
                        'PO':me.sPO,
                        'PageSize':me.pageSize,
                        'CurrentIndex':me.pageIndex -1,
                        'GoodsStatus':me.sGoodsStatus
                    }
                })
            .then((response) => {
                    if(response.data.IsSuccess)
                    {
                        
                        me.TransLogs = response.data.Data.DataSource;
                        me.recordtotal = response.data.Data.TotalRecords;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                     console.log(strMsg);   
                    }
            })
            .catch(function (error) {
                console.log(error)
            });
        },
        handleCurrentChange(val)
        {
            this.pageIndex = val;
            this.LoadData()
        },
        collapse: function() {
            this.collapsed = !this.collapsed;
        },
        formatterDecimal:function(row,column){
            var dig_str = row[column.property];
            if (dig_str === undefined || dig_str == null ) {
              return "";
            }
            var dig = parseFloat(dig_str);
            return dig.toFixed(2);
        },
        handleExport(){
            this.searching = true;
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getLogsMethod = 'TransLog/export2';
            this.$axios.get(getLogsMethod,
                {
                    params: {
                        'CurrentTokenId': user.TokenId,
                        'CurrentUser': user.LoginName, 
                        'DeveliverDtFrom':me.sDeveliverDtFrom,
                        'DeveliverDtTo':me.sDeveliverDtTo,
                        'DeveliverDtOrder':'',
                        'Destination':me.sDestination,
                        'DestinationOrder':'',
                        'StoreDtFrom':me.sStoreDtFrom,
                        'StoreDtTo':me.sStoreDtTo,
                        'StoreDtOrder':'',
                        'Receiver':'',
                        'ReceiverOrder':'',
                        'BillNo':me.sBillNo,
                        'BillNoOrder':'',
                        'Terminalinventory':'',
                        'TerminalinventoryOrder':'',
                        'ReceiptStatus':me.sReceiptStatus,
                        'ReceiptStatusOrder':'',
                        'PO':me.sPO,
                        'PageSize':me.pageSize,
                        'CurrentIndex':me.pageIndex -1,
                    }
                })
            .then((response) => {

               // this.searching = false;

                if(true) {
                    if(response.data.IsSuccess)
                    {
                        //TODO: Download the file
                        //var attachmentURL = "http://bxw2341450056.my3w.com/api/tempexportfile/" + response.data.Data;
                       // window.location = attachmentURL;
                       me.downloadFile('export.xlsx',response.data.Data);
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
               // this.searching = false;
                console.log(error);
            });
        },
        downloadFile(fileName, content) {
            const blob = this.base64ToBlob(content); // new Blob([content]);
      
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
       
              //此写法兼容可火狐浏览器
              document.body.appendChild(link);
              const evt = document.createEvent("MouseEvents");
              evt.initEvent("click", false, false);
              link.dispatchEvent(evt);
              document.body.removeChild(link);
            }
          },
          base64ToBlob(code) {
            const raw = window.atob(code);
            const rawLength = raw.length;
            const uInt8Array = new Uint8Array(rawLength);
            for (let i = 0; i < rawLength; ++i) {
              uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          },
          formatterController:function(row, column) { 
            var date_str = row[column.property];
            if (date_str == undefined || date_str =='') {
              return "";
            }
            var date = new Date(date_str);
            return date.Format("yyyy-MM-dd");
        },

        tableRowClassName({row, rowIndex}) {
            console.log(row.GoodsStatus);
            if(row.GoodsStatus == '未签收') {
                 return 'warning-row'
            } 
            else{
                return 'success-row'
            }
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/TransLog/TransLog.js